import React from 'react';
import PropTypes from 'prop-types';

const renderRemoveCheckedRow = checkedRows => checkedRows.map(c => c);

const NextOrPreviousButton = ({
  title,
  type,
  disabled,
  onClickButton,
  checkedRows,
}) => (
  <button
    className={[
      disabled ? `disabled-${type}-button` : '',
      `import-file-${type}-button`,
    ].join(' ')}
    onClick={() => !disabled && onClickButton()}
  >
    {title}
    {checkedRows && checkedRows.length && type === 'remove' ? <ul>: {renderRemoveCheckedRow(checkedRows)}</ul> : null}
  </button>
);

NextOrPreviousButton.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  onClickButton: PropTypes.func,
  checkedRows: PropTypes.array,
};

export default NextOrPreviousButton;



// WEBPACK FOOTER //
// ./src/components/organisms/ImportFile/blocks/bottomRowButton.js